module.exports = __webpack_public_path__ + "img/animation_bell.8cbd9b54.gif";